import api from "../services";

const shiftsAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllShifts: builder.query({
      query: () => ({
        url: `/api/shift/getallshifts`,
        method: "GET",
      }),
    }),
    getShiftById: builder.query({
      query: (payLoad) => ({
        url: `/api/shift/getbyid/?shiftId=${payLoad}`,
        method: "GET",
      }),
    }),
    createShift: builder.mutation({
      query: (payload) => ({
        url: `/api/shift/create`,
        method: "POST",
        body: payload,
      }),
    }),
    updateShift: builder.mutation({
      query: (payload) => ({
        url: `/api/shift/updateshift?shiftId=${payload.shiftId}`,
        method: "PUT",
        body: payload,
      }),
    }),
    deleteShift: builder.mutation({
      query: (payload) => ({
        url: `/api/shift/deleteshift?shiftId=${payload}`,
        method: "DELETE",
      }),
    }),
  }),
});

export default shiftsAPI;
export const {
  useLazyGetShiftByIdQuery,
  useCreateShiftMutation,
  useDeleteShiftMutation,
  useGetAllShiftsQuery,
  useUpdateShiftMutation,
} = shiftsAPI;
